import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { RatingStartFull } from '../../images/RatingStarFull';
import { RatingStartHalf } from '../../images/RatingStarHalf';
import { RatingStartFullMobile } from '../../images/RatingStartFullMobile';
import { RatingStartHalfMobile } from '../../images/RatingStartHalfMobile';

import s from './Metrics.scss';

interface IMetricProps {
    metric: string;
    rating?: boolean;
    text: string;
}

function Metric({ metric, rating = false, text }: IMetricProps) {
	useStyles(s);

	return (
		<div
			className={`sl-teams-metrics__metric${
				rating ? ' sl-teams-metrics__metric__with-rating' : ''
			}`}
		>
			<div className="sl-teams-metrics__metric__number">{metric}</div>
			{rating && (
				<>
					<div className="sl-teams-metrics__metric__rating">
						<RatingStartFull />
						<RatingStartFull />
						<RatingStartFull />
						<RatingStartFull />
						<RatingStartHalf />
					</div>
					<div className="sl-teams-metrics__metric__rating-mobile">
						<RatingStartFullMobile />
						<RatingStartFullMobile />
						<RatingStartFullMobile />
						<RatingStartFullMobile />
						<RatingStartHalfMobile />
					</div>
				</>
			)}
			<div className="sl-teams-metrics__metric__text">{text}</div>
		</div>
	);
}

export function Metrics() {
	return (
		<div className="sl-teams-metrics">
			<div className="sl-teams-metrics__title">
				The world’s largest code learning platform and community
			</div>
			<div className="sl-teams-metrics__container">
				<Metric metric="30M+" text="registered learners" />
				<Metric metric="#1" text="on the App Store and Google Play" />
				<Metric metric="4.8" rating text="on the App Store" />
				<Metric metric="4.7" rating text="on Google Play" />
			</div>
			<div className="sl-teams-metrics__container-mobile">
				<div className="sl-teams-metrics__pair">
					<Metric metric="30M+" text="registered learners" />
					<Metric metric="4.8" rating text="on the App Store" />
				</div>
				<div className="sl-teams-metrics__pair">
					<Metric
						metric="#1"
						text="on the App Store and Google Play"
					/>
					<Metric metric="4.7" rating text="on Google Play" />
				</div>
			</div>
		</div>
	);
}
